// extracted by mini-css-extract-plugin
export var divider = "_ow-0";
export var systemMessage = "_ow-1";